import React from 'react'
import CloseButtonFilledSVG from "../../../assets/icons/close-button-filled.svg"
export const CloseButtonFilled: React.FC = () => {
  return (
    <img src={CloseButtonFilledSVG} alt="" className="w-[16px] h-[16px] cursor-pointer" />
  )
}
